import React, { useMemo } from 'react';
import { adSurfaceEnabled } from '../../config/ads';
import { adSlotVisible } from '../../utils/adsEnabled';
import { pickStaticAd } from '../../data/staticAds';
import { isValidAdDestination } from '../../utils/adDestinationUrl';
import { AdCardContainer, AdMedia, AdLabel, AdMeta, AdTitle, AdSponsor, AdCta } from './AdImageSlot.styled';

/**
 * Image-based slot. Uses `ad` when provided (e.g. managed merge); otherwise static `pickStaticAd`.
 */
export default function AdImageSlot({ size = 'medium', position = 'sidebar', slot, children, ad: adProp, pageKey, onLinkClick }) {
  const index = typeof slot === 'number' ? slot : 0;
  const staticAd = useMemo(() => pickStaticAd({ position, size, slot: index }), [position, size, index]);
  const ad = adProp || staticAd;

  const handleClick = (e) => {
    const dest = isValidAdDestination(ad?.url);
    if (!dest) e.preventDefault();
    else onLinkClick?.(e);
  };

  if (!adSurfaceEnabled() || (pageKey && !adSlotVisible(pageKey)) || !ad || !ad.image) return null;

  const dest = isValidAdDestination(ad.url);
  const isSidebar = position === 'sidebar';

  return (
    <AdCardContainer
      href={dest ? ad.url : '#'}
      onClick={handleClick}
      target={dest ? '_blank' : undefined}
      rel={dest ? 'noopener noreferrer sponsored' : undefined}
      $size={size}
      $position={position}
    >
      <AdLabel>Advertisement</AdLabel>
      {children || (
        <>
          <AdMedia $position={position}>
            <img src={ad.image} alt={ad.title} loading="lazy" decoding="async" />
          </AdMedia>
          {isSidebar && (
            <AdMeta>
              <AdTitle>{ad.title}</AdTitle>
              <AdSponsor>{ad.sponsor}</AdSponsor>
              {ad.cta && <AdCta>{ad.cta}</AdCta>}
            </AdMeta>
          )}
        </>
      )}
    </AdCardContainer>
  );
}
